import { cn } from "@/lib/utils";

// Bolha de mensagem (user à direita, assistente à esquerda). Texto puro; markdown
// fica para uma iteração futura. `whitespace-pre-wrap` preserva quebras da resposta.
export function MessageBubble({ role, content }: { role: "USER" | "ASSISTANT"; content: string }) {
  const isUser = role === "USER";
  return (
    <div className={cn("flex", isUser ? "justify-end" : "justify-start")}>
      <div
        className={cn(
          "max-w-[85%] whitespace-pre-wrap rounded-lg px-3 py-2 text-sm",
          isUser ? "bg-primary text-primary-foreground" : "bg-muted text-foreground"
        )}
      >
        {content}
      </div>
    </div>
  );
}
